import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { getOnboardedAppHome } from "@/features/auth/utils/getAuthenticatedPublicLanding";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design")({
    component: () => <Outlet />,
    beforeLoad: async ({ context }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        // Roles are loaded in `/_app`'s loader, which runs after child beforeLoads.
        // Resolve them here so a refresh of /design/* does not treat an admin as signed out.
        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        if (!context.auth.roles.isAdmin) {
            throw redirect({ to: getOnboardedAppHome(context.auth.roles) });
        }

        return context;
    },
});
